export const batesNumbering = {
  "title": "Add Bates Numbering",
  "removeMessage": "Do you want to delete the Bates Number from document?",
  "removeNoneMessage": "Foxit PDF Editor can't find any Bates Number in the document.",
  "succesMessage": "Bates Number has been successfully applied to {success} of {total} PDF files.",
  "outputOptions": {
    "name": "Output Options",
    "keep": "Keep original file names",
    "add": "Add to original file names:",
    "replace": "Replace file names with starting and ending Bates number(e.g.000100-000115.pdf)",
    "before": "Insert Before",
    "after": "Insert After",
    "fileName": "+ original file name + "
  },
  "table": {
    "fileName": "File Name",
    "type": "Type",
    "size": "Size",
    "modified": "Modified"
  },
  "total": "Total {count} File(s)",
  "addFiles": "Add Files",
  "addOpenFiles": "Add Open Files",
  "overSize": "The total exceeds limit (5)",
  "sameName": "The file already exists, there is no need to choose it again.",
  "optionDlg": {
    "name": "Bates Numbering Options",
    "numberOfDigits": "Number of Digits: ",
    "startNumber": "Start Number: ",
    "increment": "Increment: ",
    "rotateAngle": "Rotate Angle: ",
    "prefix": "Prefix: ",
    "suffix": "Suffix: "
  },
  "batesRotateInfoTitle": "rotation value",
  "batesRotateInfo": "If you have two or more sets of Bates numbers in the same location, they must have the same rotation values. Adding Bates numbering with a different rotation value will overwrite the old rotation value.",
  "emptyMessage": "The Bates Number is empty, do you want to cancel this operation? Click \"OK\" to exit the Bates Number dialog box, or click \"Cancel\" to continue with the current operations.",
  "permissionAlert": "You don't have sufficient permissions to access the document."
}